(function () {
    'use strict';

    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
        console.warn('Animations: GSAP or ScrollTrigger not found.');
        return;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
    }

    gsap.registerPlugin(ScrollTrigger);

    var CONFIG = {
        scrollStart: 'top 84%',
        ease: 'power2.out',
        easeImage: 'power2.out',
        durationUp: 0.75,
        durationImage: 0.9,
        durationStagger: 0.7,
        staggerDefault: 0.12,
        translateY: 28,
        translateX: -36,
        scaleFrom: 0.97,
    };

    var STAGGER = {
        'stagger-benefits': 0.12,
        'stagger-instructors': 0.12,
        'stagger-lessons': 0.12,
        'stagger-list': 0.1,
        'stagger-cards': 0.12,
    };

    var CHILD = {
        'stagger-benefits': '.benefit-card-wrapper',
        'stagger-instructors': '.instructor-card',
        'stagger-lessons': '.lesson-card',
        'stagger-list': 'li',
        'stagger-cards': '.card',
    };

    function extraDelay(el) {
        var value = el.getAttribute('data-animate-delay');
        return value ? parseFloat(value) : 0;
    }

    function onScrollEnter(trigger, onEnter) {
        ScrollTrigger.create({
            trigger: trigger,
            start: CONFIG.scrollStart,
            once: true,
            onEnter: onEnter,
        });
    }

    function animateFadeUp(el) {
        var delay = extraDelay(el);

        gsap.set(el, { opacity: 0, y: CONFIG.translateY });

        onScrollEnter(el, function () {
            gsap.to(el, {
                opacity: 1,
                y: 0,
                duration: CONFIG.durationUp,
                ease: CONFIG.ease,
                delay: delay,
                clearProps: 'transform',
            });
        });
    }

    function animateFadeScale(el) {
        var delay = extraDelay(el);

        gsap.set(el, { opacity: 0, scale: CONFIG.scaleFrom });

        onScrollEnter(el, function () {
            gsap.to(el, {
                opacity: 1,
                scale: 1,
                duration: CONFIG.durationImage,
                ease: CONFIG.easeImage,
                delay: delay,
                clearProps: 'transform',
            });
        });
    }

    function animateFadeLeft(el) {
        var delay = extraDelay(el);

        gsap.set(el, { opacity: 0, x: CONFIG.translateX });

        onScrollEnter(el, function () {
            gsap.to(el, {
                opacity: 1,
                x: 0,
                duration: CONFIG.durationUp,
                ease: CONFIG.ease,
                delay: delay,
                clearProps: 'transform',
            });
        });
    }

    function animateStagger(parent, childSelector, staggerAmount) {
        var children = parent.querySelectorAll(childSelector);

        if (!children.length) {
            return;
        }

        gsap.set(children, { opacity: 0, y: CONFIG.translateY });

        onScrollEnter(parent, function () {
            gsap.to(children, {
                opacity: 1,
                y: 0,
                duration: CONFIG.durationStagger,
                ease: CONFIG.ease,
                stagger: staggerAmount,
                clearProps: 'transform',
            });
        });
    }

    document.querySelectorAll('[data-animate]').forEach(function (el) {
        var type = el.getAttribute('data-animate');

        if (type === 'fade-up') {
            animateFadeUp(el);
            return;
        }

        if (type === 'fade-scale') {
            animateFadeScale(el);
            return;
        }

        if (type === 'fade-left') {
            animateFadeLeft(el);
            return;
        }

        if (STAGGER[type] && CHILD[type]) {
            animateStagger(el, CHILD[type], STAGGER[type]);
        }
    });
})();
